import { StandardEvents } from '@shopify/events';
class CalinProductEan extends HTMLElement {
  connectedCallback() {
    this.target = this.closest('[id*="ProductInformation-"], [id*="QuickAdd-"], product-component');
    this.target?.addEventListener(StandardEvents.productSelect, this.update);
  }
  disconnectedCallback() {
    this.target?.removeEventListener(StandardEvents.productSelect, this.update);
  }
  update = (event) => {
    this.hidden = true;
    event.promise.then(({ detail }) => {
      if (!this.isConnected || !detail) return;
      if (detail.productId && String(detail.productId) !== this.dataset.productId && !detail.newProduct) return;
      const source = Array.from(detail.html?.querySelectorAll('calin-product-ean') || []).find(
        (element) => element.dataset.eanBlock === this.dataset.eanBlock
      );
      const value = source ? source.querySelector('[data-ean-value]')?.textContent || '' : detail.resource?.barcode || '';
      this.querySelector('[data-ean-value]').textContent = value;
      this.hidden = !value;
      if (detail.newProduct) this.dataset.productId = String(detail.newProduct.id);
    }).catch(() => { this.hidden = true; });
  };
}
if (!customElements.get('calin-product-ean')) customElements.define('calin-product-ean', CalinProductEan);
